import React, { useEffect, useRef, useState } from "react";
import { useInView, useMotionValue, useSpring, useTransform } from "framer-motion";

/**
 * Counter — animates a numeric value from 0 → target when scrolled into view.
 * Preserves the visual weight of the original (prefix like $, suffix like + or ×).
 */
export default function Counter({
  value,             // numeric target (e.g. 14, 1, 9, 40)
  prefix = "",       // "$"
  suffix = "",       // "+" | "×" | "M+" etc.
  duration = 1.6,
  className = "",
  decimals = 0,
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10% 0px -10% 0px" });
  const motionValue = useMotionValue(0);
  const spring = useSpring(motionValue, {
    duration: duration * 1000,
    damping: 22,
    stiffness: 80,
  });
  const display = useTransform(spring, (v) => {
    const n = decimals > 0 ? v.toFixed(decimals) : Math.round(v).toLocaleString();
    return `${prefix}${n}${suffix}`;
  });

  const [text, setText] = useState(`${prefix}0${suffix}`);

  useEffect(() => {
    const unsub = display.on("change", setText);
    return unsub;
  }, [display]);

  useEffect(() => {
    if (inView) motionValue.set(value);
  }, [inView, motionValue, value]);

  return (
    <span ref={ref} className={`number-tabular ${className}`}>
      {text}
    </span>
  );
}
